import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const CircleCheckedIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
}) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5026 22.9166C18.2556 22.9166 22.9193 18.2529 22.9193 12.5C22.9193 6.74701 18.2556 2.08331 12.5026 2.08331C6.74964 2.08331 2.08594 6.74701 2.08594 12.5C2.08594 18.2529 6.74964 22.9166 12.5026 22.9166Z"
        fill="white"
      />
      <path
        d="M11.0234 16.2293C10.8151 16.2293 10.6172 16.1459 10.4714 16.0001L7.52344 13.0522C7.22135 12.7501 7.22135 12.2501 7.52344 11.948C7.82552 11.6459 8.32552 11.6459 8.6276 11.948L11.0234 14.3439L16.3776 8.98969C16.6797 8.6876 17.1797 8.6876 17.4818 8.98969C17.7839 9.29177 17.7839 9.79177 17.4818 10.0939L11.5755 16.0001C11.4297 16.1459 11.2318 16.2293 11.0234 16.2293Z"
        fill="#3B9F17"
      />
    </CustomSvg>
  );
};
export default CircleCheckedIcon;
